const COOKIE_CONSENT_NAME = "vintreeConsent";
const PRIVACY_PREFERENCES_STORAGE_KEY = "vintreePrivacyPreferences";
const PRIVACY_CONSENT_CHANGE_EVENT = "vintree:privacy-consent-change";
const CONSENT_MAX_AGE_DAYS = 150;

function getCookieValue(name) {
  if (typeof document === "undefined") return null;
  const cookie = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(`${name}=`));

  return cookie ? decodeURIComponent(cookie.split("=").slice(1).join("=")) : null;
}

function setCookieValue(name, value) {
  if (typeof document === "undefined") return;
  const maxAge = CONSENT_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

function hasCookieConsentDecision() {
  return getCookieValue(COOKIE_CONSENT_NAME) !== null;
}

function hasAcceptedCookieConsent() {
  const value = getCookieValue(COOKIE_CONSENT_NAME);
  return value === "true" || value === "1" || value === "accepted";
}

function getStoredPrivacyPreferences() {
  if (typeof window === "undefined") {
    return {
      analytics: false,
      marketing: false,
    };
  }

  try {
    const stored = window.localStorage.getItem(PRIVACY_PREFERENCES_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        analytics: Boolean(parsed.analytics),
        marketing: Boolean(parsed.marketing),
      };
    }
  } catch (error) {
    console.error("Erro ao ler preferencias de privacidade:", error);
  }

  const accepted = hasAcceptedCookieConsent();
  return {
    analytics: accepted,
    marketing: accepted,
  };
}

function savePrivacyPreferences(preferences) {
  if (typeof window === "undefined") return;

  const normalized = {
    analytics: Boolean(preferences.analytics),
    marketing: Boolean(preferences.marketing),
  };

  window.localStorage.setItem(
    PRIVACY_PREFERENCES_STORAGE_KEY,
    JSON.stringify(normalized)
  );

  const cookieValue =
    normalized.analytics && normalized.marketing
      ? "true"
      : normalized.analytics || normalized.marketing
      ? "custom"
      : "false";
  setCookieValue(COOKIE_CONSENT_NAME, cookieValue);

  window.dispatchEvent(
    new CustomEvent(PRIVACY_CONSENT_CHANGE_EVENT, {
      detail: normalized,
    })
  );
}

function acceptAllPrivacyPreferences() {
  savePrivacyPreferences({ analytics: true, marketing: true });
}

function declineOptionalPrivacyPreferences() {
  savePrivacyPreferences({ analytics: false, marketing: false });
}

function isAnalyticsConsentEnabled() {
  return getStoredPrivacyPreferences().analytics;
}

function isMarketingConsentEnabled() {
  return getStoredPrivacyPreferences().marketing;
}

export {
  COOKIE_CONSENT_NAME,
  PRIVACY_CONSENT_CHANGE_EVENT,
  acceptAllPrivacyPreferences,
  declineOptionalPrivacyPreferences,
  getCookieValue,
  getStoredPrivacyPreferences,
  hasAcceptedCookieConsent,
  hasCookieConsentDecision,
  isAnalyticsConsentEnabled,
  isMarketingConsentEnabled,
  savePrivacyPreferences,
};
